import { render, staticRenderFns } from "./bugs.vue?vue&type=template&id=3a7eda10&scoped=true&"
import script from "./bugs.vue?vue&type=script&lang=js&"
export * from "./bugs.vue?vue&type=script&lang=js&"
import style0 from "./bugs.vue?vue&type=style&index=0&id=3a7eda10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7eda10",
  null
  
)

export default component.exports